(function () {
  'use strict';
  if (window.__hhFaq8WidgetGuard) return;
  var config = document.querySelector('script[data-hh-faq8-widget-script]');
  if (!config) return;
  window.__hhFaq8WidgetGuard = true;
  var allowed = config.getAttribute('data-variants').split(',');
  var html = document.documentElement;
  var style = document.getElementById('hh-faq8-widget-guard-style');
  if (!style) {
    style = document.createElement('style');
    style.id = 'hh-faq8-widget-guard-style';
    style.textContent = 'html[data-hh-faq8-widget-guard] #clarity-agents-preview-host{' +
      'visibility:hidden!important;content-visibility:hidden!important;}' +
      'html[data-hh-faq8-hide-support] #bik-chat-iframe[data-hh-faq8-closed-support]{' +
      'visibility:hidden!important;pointer-events:none!important;}';
    document.head.appendChild(style);
  }
  var queued = false;
  var observedFrame = null;
  var observedDocument = null;
  var innerObserver = null;
  var controls = '[data-hh-pdp] button,[data-hh-pdp] a,[data-hh-pdp] summary,' +
    '[data-hh-pdp] input,[data-hh-pdp] select,[data-hh-pdp] textarea,[data-hh-pdp-faq]';

  function intersects(a, b) {
    return a.width > 0 && a.height > 0 && a.bottom > 0 && a.top < window.innerHeight &&
      a.right + 8 > b.left && a.left - 8 < b.right && a.bottom + 8 > b.top && a.top - 8 < b.bottom;
  }

  function closedLauncher(frame) {
    if (frame !== observedFrame) {
      if (observedFrame) observedFrame.removeEventListener('load', schedule);
      observedFrame = frame;
      if (frame) frame.addEventListener('load', schedule);
    }
    var doc = null;
    try { doc = frame && frame.contentDocument; } catch (e) { /* Unknown/open states remain visible. */ }
    if (doc !== observedDocument) {
      if (innerObserver) innerObserver.disconnect();
      observedDocument = doc;
      if (doc) {
        innerObserver = new MutationObserver(schedule);
        innerObserver.observe(doc.body || doc, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
      }
    }
    if (!frame) return false;
    if (doc && doc.body) {
      return !doc.querySelector('#bikChatWindowWrapper,.chatbot-wrapper') &&
        !!doc.querySelector('[data-testid="bikCtaContainer"] [data-testid="bikCtaButton"]');
    }
    return frame.hasAttribute('data-hh-pdp-chat-compact');
  }

  function update() {
    queued = false;
    var select = document.querySelector('[data-hh-pdp-variant-select]');
    var faq = document.querySelector('[data-hh-pdp-approved-faq][data-variant-id]');
    var active = !!(select && faq && allowed.indexOf(select.value) !== -1 && faq.getAttribute('data-variant-id') === select.value);
    html.toggleAttribute('data-hh-faq8-widget-guard', active);
    var frame = document.querySelector('#bik-chat-iframe');
    var closed = closedLauncher(frame);
    if (frame) frame.toggleAttribute('data-hh-faq8-closed-support', active && closed);
    var collision = false;
    if (active && closed && frame) {
      var bounds = frame.getBoundingClientRect();
      var nodes = document.querySelectorAll(controls);
      for (var i = 0; i < nodes.length; i++) {
        var computed = window.getComputedStyle(nodes[i]);
        if (computed.display !== 'none' && computed.visibility !== 'hidden' && intersects(nodes[i].getBoundingClientRect(), bounds)) {
          collision = true;
          break;
        }
      }
    }
    html.toggleAttribute('data-hh-faq8-hide-support', collision);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(update);
  }
  document.addEventListener('scroll', schedule, { capture: true, passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('change', schedule, true);
  document.addEventListener('toggle', schedule, true);
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['data-variant-id', 'data-hh-pdp-chat-compact', 'style', 'open']
  });
  schedule();
})();
